/* eslint-disable @typescript-eslint/no-explicit-any */
// routes.js
import React from 'react'
import NotFound from '../Pages/ErrorPage/notfound'

import { Suspense, lazy } from 'react'

import { Navigate, type RouteObject } from 'react-router-dom'
import AppPage from '../Pages/AppPage/apppage'
import VendorAppRoutes from './vendorRoutes'
import { Spin } from 'antd'
import TrackPage from '../Pages/OnTrack/track'
// import AuthGuard from "../Guards/AuthGuard";

const Loadable = (Component: any) => (props: JSX.IntrinsicAttributes) => (
  <Suspense
    fallback={
      <div>
        <Spin size='large' />
      </div>
    }
  >
    <Component {...props} />
  </Suspense>
)

// *  AUTHENTICATION PAGES
const LandingPage = Loadable(
  lazy(() => import('../Pages/LandingPage/landingpage'))
)
const OnBoardingPage = Loadable(
  lazy(() => import('../Pages/onBoardingPage/onBoardingPage'))
)

const routes: RouteObject[] = [
  {
    path: 'vendor',
    children: [
      {
        path: 'login',
        element: <LandingPage />
      },
      {
        path: 'onTrack/:orderId',
        element: <TrackPage />
      },
      {
        path: 'registration',
        element: <OnBoardingPage />
      },
      {
        path: 'app/*',
        element: <VendorAppRoutes />
      }
    ]
  },
  {
    path: '/',
    element: <Navigate to='/vendor/login' replace />
  },
  {
    path: '*',
    element: <NotFound />
  }
]

export default routes
// function MainRoutes() {
//   return (
//     <>
//       {" "}
//       <Route
//         path="/vendorLogin"
//         element={<LandingPage />}
//         errorElement={<NotFound />}
//       />
//       <Route path="/" element={<LandingPage />} errorElement={<NotFound />} />
//       <Route path="*" element={<NotFound />} errorElement={<NotFound />} />
//     </>
//   );
// }

// export default MainRoutes;
